import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import ModifySubscription from './modify-subscription';
import {
  getConnectedUsersAndEmailAccountsRequest,
  getAccountSubscriptionRequest,
  getPlansRequest,
  purchaseSubscriptionRequest,
  applyCouponCodeRequest,
  modifySubscriptionRequest,
  purchaseModifySubscriptionRequest,
  calculatePayRequest,
  upgradePlanRequest,
  downgradePlanRequest,
  upgradeLtdPlanRequest,
  modifyLtdPlanRequest,
} from '../../extra-actions';
import {
  PurchaseSubscriptionRequest,
  ApplyCouponCodeRequest,
  ModifySubscriptionRequest,
  PurchaseModifySubscriptionRequest,
  CalculatePayRequest,
  UpgradePlanRequest,
  DowngradePlanRequest,
  LTDUpgradePayload,
  LTDModifyPayload,
} from '../../types';
import {
  deleteAppliedCouponCode,
  resetCalculatePayState,
  resetConnectedUsersAndEmailAccountsRequest,
  resetModifySubscriptionResponse,
  resetPurchaseModifySubscriptionResponse,
  selectPlan,
} from '../../billing-subscription-slice';

const mapStateToProps = (state: RootState) => ({
  sendGetAccountSubscriptionRequestStatus:
    state.billingAndSubscription.getAccountSubscriptionRequest.status,
  sendGetAccountSubscriptionRequestError:
    state.billingAndSubscription.getAccountSubscriptionRequest.error,
  sendGetPlansRequestStatus:
    state.billingAndSubscription.getPlansRequest.status,
  sendGetPlansRequestError: state.billingAndSubscription.getPlansRequest.error,
  sendPurchaseSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseSubscriptionRequest.status,
  sendGetAccountSubscriptionResponse:
    state.billingAndSubscription.getAccountSubscriptionResponse,
  sendGetConnectedUsersAndEmailAccountsRequestStatus:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest
      .status,
  sendGetConnectedUsersAndEmailAccountsRequestError:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest.error,
  sendGetConnectedUsersAndEmailAccountsRequestResponse:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse,
  sendApplyCouponCodeRequestStatus:
    state.billingAndSubscription.applyCouponCodeRequest.status,
  sendApplyCouponCodeRequestMessage:
    state.billingAndSubscription.applyCouponCodeRequest.message,
  sendApplyCouponCodeRequestError:
    state.billingAndSubscription.applyCouponCodeRequest.error,
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,
  sendGetPlansResponse: state.billingAndSubscription.getPlansResponse,
  sendGetModifySubscriptionRequestStatus:
    state.billingAndSubscription.calculatePayRequest.status,
  sendGetPurchaseModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseModifySubscriptionRequest.status,
  sendGetModifySubscriptionResponse:
    state.billingAndSubscription.modifySubscriptionResponse,
  sendGetCalculatePayResponse:
    state.billingAndSubscription.getCalculatePayResponse,
  selectedPlanDetails: state.billingAndSubscription.selectedPlanDetails,

  upgradeLtdPlanRequestStatus:
    state.billingAndSubscription.upgradeLtdPlanRequest.status,
  upgradeLtdPlanRequestError:
    state.billingAndSubscription.upgradeLtdPlanRequest.error,
  modifyLtdPlanRequestStatus:
    state.billingAndSubscription.modifyLtdPlanRequest.status,
  modifyLtdPlanRequestError:
    state.billingAndSubscription.modifyLtdPlanRequest.error,

  userCurrentPlan: state.home.subscription?.planCode,
  subscriptionPlanStatus: state.home.subscription?.status,
});

const mapDispatchToProps = {
  sendGetAccountSubscriptionRequest: () => getAccountSubscriptionRequest(),
  sendGetPlansRequest: () => getPlansRequest(),
  sendPurchaseSubscriptionRequest: (payload: PurchaseSubscriptionRequest) =>
    purchaseSubscriptionRequest(payload),
  sendApplyCouponCodeRequest: (payload: ApplyCouponCodeRequest) =>
    applyCouponCodeRequest(payload),
  sendGetConnectedUsersAndEmailAccountsRequest: () =>
    getConnectedUsersAndEmailAccountsRequest(),
  resetConnectedUsersAndEmailAccountsRequest: () =>
    resetConnectedUsersAndEmailAccountsRequest(),
  deleteAppliedCouponCode: () => deleteAppliedCouponCode(),
  sendModifySubscriptionRequest: (payload: ModifySubscriptionRequest) =>
    modifySubscriptionRequest(payload),
  sendPurchaseModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseModifySubscriptionRequest(payload),
  resetModifySubscriptionResponse: () => resetModifySubscriptionResponse(),
  resetCalculatePayState: () => resetCalculatePayState(),
  resetPurchaseModifySubscriptionResponse: () =>
    resetPurchaseModifySubscriptionResponse(),
  sendGetCalculatePayRequest: (payload: CalculatePayRequest) =>
    calculatePayRequest(payload),
  sendUpgradePlanRequest: (payload: UpgradePlanRequest) =>
    upgradePlanRequest(payload),
  sendDowngradePlanRequest: (payload: DowngradePlanRequest) =>
    downgradePlanRequest(payload),
  selectPlan: (payload) => selectPlan(payload),
  hideLoading: () => hideLoading(),
  showLoading: () => showLoading(),

  sendUpgradeLtdPlanRequest: (payload: LTDUpgradePayload) =>
    upgradeLtdPlanRequest(payload),

  sendModifyLtdPlanRequest: (payload: LTDModifyPayload) =>
    modifyLtdPlanRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export type LocationStateType = {
  isModifySubscription: boolean;
};

export default connector(ModifySubscription);
